import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/use-auth";

export interface AiQuotaStatus {
  plan: string;
  daily_used: number;
  daily_limit: number;
  monthly_used: number;
  monthly_limit: number;
}

/**
 * Reads the current user's AI consumption vs. plan caps.
 * Backed by the `ai_quota_status` RPC (see migration).
 */
export function useAiQuota() {
  const { user } = useAuth();
  const [data, setData] = useState<AiQuotaStatus | null>(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) {
      setData(null);
      return;
    }
    setLoading(true);
    try {
      const { data: rows, error } = await supabase.rpc("ai_quota_status");
      if (error) throw error;
      const row = Array.isArray(rows) ? rows[0] : rows;
      if (row) setData(row as AiQuotaStatus);
    } catch {
      // silent — UI just hides counter
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return { quota: data, loading, refresh };
}